import { render, staticRenderFns } from "./MedicationForm.vue?vue&type=template&id=3ad75b71&scoped=true"
import script from "./MedicationForm.vue?vue&type=script&lang=js"
export * from "./MedicationForm.vue?vue&type=script&lang=js"
import style0 from "./MedicationForm.vue?vue&type=style&index=0&id=3ad75b71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad75b71",
  null
  
)

export default component.exports